// src/components/planning/EditReadingsModal/components/ReadingForm.tsx
import React from 'react';
import { Form } from 'react-bootstrap';
import { ReadingFormProps } from './types';
import { READING_FIELDS } from './constants';

export const ReadingForm: React.FC<ReadingFormProps> = ({
  editedReadings,
  onInputChange
}) => (
  <Form>
    {READING_FIELDS.map(field => (
      <Form.Group className="mb-3" key={field.id}>
        <Form.Label>{field.label}</Form.Label>
        <Form.Control
          type="text"
          value={editedReadings[field.key] || ''}
          onChange={(e) => onInputChange(field.key, e.target.value)}
          placeholder={field.placeholder}
        />
      </Form.Group>
    ))}
  </Form>
);